// Components
import { ActionButton, Input, Navbar, Section, SplashStatus } from "components"
import { Col, Row } from "reactstrap"

// Third-Party Library
import { Navigate, Route, Routes } from "react-router-dom"

// API
import { useQueries, useQuery } from "react-query"
import { Api } from "./api"
import { SettingApi } from "api"

// Config
import menu from "navigations/dayPassesNav"
import { logo } from "Config"

// Form
import * as yup from "yup"
import { Controller, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"

// Functions
import { toast } from "functions"

const DayPassesRouter = ({ baseLink }) => {
  // API
  const fetchData = useQueries([
    { queryKey: ['dayPasses', 'router'], queryFn: Api.companies },
    { queryKey: ['setting', 'tax_services'], queryFn: SettingApi.tax_services }
  ])

  if (fetchData[0].isLoading || fetchData[0].isError) {
    return (
      <SplashStatus loading={fetchData[0].isLoading} />
    )
  } else if (fetchData[1].isLoading || fetchData[1].isError) {
    return (
      <SplashStatus loading={fetchData[1].isLoading} />
    )
  } else {
    // Variables
    const data = fetchData[0].data

    return (
      <div className="min-vh-100 d-flex flex-column">
        {/* Navbar */}
        <Navbar
          sticky="top"
          logo={logo}
          baseLink={baseLink}
          menu={menu}
          noColorChange
        />

        {/* Banner */}
        {/* <Banner fetchData={fetchData} /> */}

        {/* Routes */}
        <section>
          <Routes>
            {menu.map((val, index) => {
              return (
                <Route
                  key={index}
                  path={val.link}
                  element={(
                    <val.component
                      baseData={data}
                      setting={{
                        tax_services: fetchData[1].data
                      }} 
                    />
                  )}
                />
              )
            })}

            <Route path="*" element={<Navigate to="/error/404" replace />} />
          </Routes>
        </section>

        <Section>
          <CompanySection />
        </Section>

        {/* Footer */}
        <footer
          style={{
            backgroundColor: '#333333',
            backgroundSize: 'cover',
            paddingBottom: '5rem'
          }}
          className="mt-auto pt-5"
        >
          <div className="container">
            <Row>
              <Col md={6} className="px-4 mb-5">
                <h5 className="text-white mb-3">ADDRESS</h5>

                <section>
                  <div className="text-primary">FINNS RECREATION CLUB</div>
                  <div className="text-white">{data.address}</div>
                </section>
              </Col>

              <Col md={6} className="px-4 mb-4">
                <h5 className="text-white mb-3">NEWSLETTER SIGNUP</h5>
                <FormSection />
              </Col>
            </Row>
          </div>
        </footer>
      </div>
    )
  }
}

function CompanySection() {
  // API
  const fetchData = useQuery(['daypasses', 'grid-companies'], Api.grid_companies)

  if (fetchData.isLoading) {
    return (
      <div className="text-center my-5">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    )
  } else {
    return (
      <Row>
        {fetchData.data.map((item, key) => (
          <Col md={6} lg={4} xl={3} className="mb-3 text-center">
            <a key={key} href={item.website} target="_blank" className="text-decoration-none" rel="noreferrer">
              <div className="company-img">
                <img src={item.background} alt={item.name} style={{ height: 200, width: "100%", objectFit: "cover" }} />
              </div>

              <div className="py-2 text-black text-capitalize" style={{ backgroundColor: "#F6F6F6" }}>{item.name}</div>

              {item.etc && (
                <ActionButton color="primary" className="text-white mt-2">
                  <div style={{ fontSize: "0.875rem" }} dangerouslySetInnerHTML={{ __html: item.etc }} />
                </ActionButton>
              )}
            </a>
          </Col>
        ))}
      </Row>
    )
  }
}

function FormSection() {
  // Form
  const defaultValues = {
    first_name: "",
    last_name: "",
    email: "",
    phone: ""
  }
  const validationSchema = yup.object().shape({
    first_name: yup.string().label("First Name").required(),
    last_name: yup.string().label("Last Name").required(),
    email: yup.string().email().label("Email").required(),
    phone: yup.string().label("Phone")
  })
  const { control, formState, handleSubmit, reset } = useForm({
    defaultValues,
    resolver: yupResolver(validationSchema)
  })
  const onSubmit = value => {
    return new Promise((resolve) => {
      Api.active_campaign(value).then(res => {
        reset()
        toast("success", "Subscribe Success")
      }).catch(err => {
        toast("error", err.response.data.message)
      }).finally(resolve)
    })
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Controller
        control={control}
        name="first_name"
        render={({ field, fieldState }) => <Input {...field} noLabel ref={null} placeholder="First Name" errors={fieldState.error?.message} />}
      />

      <Controller
        control={control}
        name="last_name"
        render={({ field, fieldState }) => <Input {...field} noLabel ref={null} placeholder="Last Name" errors={fieldState.error?.message} />}
      />

      <Controller
        control={control}
        name="email"
        render={({ field, fieldState }) => <Input {...field} noLabel type="email" ref={null} placeholder="Email" errors={fieldState.error?.message} />}
      />

      <Controller
        control={control}
        name="phone"
        render={({ field, fieldState }) => <Input {...field} noLabel ref={null} placeholder="Phone" errors={fieldState.error?.message} />}
      />

      <ActionButton block loading={formState.isSubmitting}>SUBSCRIBE NOW</ActionButton>
    </form>
  )
}

export default DayPassesRouter